





























































import moment from 'moment';
import formatValue from '../../../utils/fieldMappers/formatValue';
import { overviewMap } from '../../../utils/fieldMappers/overviewMapper';

export default {
  name: 'AccountTable',
  props: ['product'],
  data: () => ({
    formatValue: formatValue,
    overviewMap: overviewMap,
  }),
  computed: {
    field: function () {
      if (this.product.isActive) {
        return this.overviewMap[this.product.accountProductType].active;
      } else {
        return this.overviewMap[this.product.accountProductType].closed;
      }
    },
    paymentSuspended() {
      if (this.field.f3 && formatValue(this.field.f3.key, this.product) === 'Suspended') {
        return true;
      }
      return false;
    },
  },
};
